import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import { GoToTop } from '#/components/layout/goto-top.tsx';
import { GITHUB_LINK } from '#/components/layout/goto-top.utils.ts';

export const Route = createFileRoute('/_main/readme')({
	component: ReadmeLayout,
});

function ReadmeLayout() {
	return (
		<div className="container max-w-6xl py-20">
			<Suspense
				fallback={
					<div className="flex min-h-[60vh] items-center justify-center">
						<div className="size-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
					</div>
				}
			>
				<Outlet />
			</Suspense>
			<GoToTop links={[GITHUB_LINK]} />
		</div>
	);
}
